import React from "react";
import { classNames } from "../../helpers/classNames";
import dayjs from "dayjs";

const SubscriptionItem = ({ data, isSmall }) => {
  const statusHexColorMap = {
    active: "#06D6A0",
    inactive: "#ef427c",
    trialing: "#4f46e5",
    expiring: "#4f46e5",
    expired: "#fb923c",
    cancelled: "#ef427c",
    initiated: "#06D6A0",
    past_due: "#4f46e5",
    failed: "#fb923c",
    incomplete: "#ef427c",
    refunded: "#06D6A0",
  };
  // console.log(data);
  return (
    <>
      <div
        className="relative block z-0 overflow-hidden bg-white py-4 px-4 rounded-lg border border-md-pink-light-1 hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 hover:bg-md-pink-light-2"
        style={{
          "--statusColor": statusHexColorMap[data?.paymentGateway?.status],
        }}
      >
        <div
          className="absolute top-1/2 left-0 h-full aspect-square z-[-1] -translate-y-1/2 -translate-x-1/2 rounded-full blur-xl opacity-10"
          style={{ backgroundColor: "var(--statusColor)" }}
        />
        <div
          className={classNames(
            "flex",
            isSmall ? "flex-col-reverse gap-2 3xl:flex-row 3xl:gap-0" : ""
          )}
        >
          <div className="flex-shrink flex-grow space-y-2">
            <h2 className="text-base 2xl:text-lg font-semibold text-md-dark !leading-none">
              {data?.planData?.name}
            </h2>
            <div className="relative">
              {/* <div className="text-xs 2xl:text-sm text-slate-500">
                <span className="text-md-dark font-semibold">Validity:</span>{" "}
                {dayjs(data?.startDate).format("DD MMM, YYYY") +
                  " - " +
                  dayjs(data?.endDate).format("DD MMM, YYYY")}
              </div> */}
              <div className="text-xs 2xl:text-sm text-slate-500">
                <span className="text-md-dark font-semibold">
                  Transaction ID:
                </span>{" "}
                {data?.paymentGateway?.transactionId}
              </div>
              <div className="text-xs 2xl:text-sm text-slate-500">
                <span className="text-md-dark font-semibold">
                  Payment Gateway:
                </span>{" "}
                {data?.planData?.planPricingData?.gateway}
              </div>
              {/* <div className="text-xs 2xl:text-sm text-slate-500">
                <span className="text-md-dark font-semibold">Plan ID:</span>{" "}
                {data?.planData?.planPricingData?.plan}
              </div> */}
              <div className="text-xs 2xl:text-sm text-slate-400">
                {dayjs(data?.createdAt).format("DD MMM, YYYY")}
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div
              className="relative text-[10px] inline-flex items-center gap-x-1 leading-none uppercase py-1 px-1 rounded-full tracking-widest font-semibold"
              style={{ color: "var(--statusColor)" }}
            >
              <div
                className="absolute top-0 left-0 w-full h-full rounded-xl opacity-10"
                style={{ backgroundColor: "var(--statusColor)" }}
              />
              <div
                className="absolute top-0 left-0 w-full h-full rounded-xl border opacity-10"
                style={{ borderColor: "var(--statusColor)" }}
              />
              <div
                className="w-3 h-3 rounded-full animate-pulse"
                style={{ backgroundColor: "var(--statusColor)" }}
              />
              <span className="px-1">{data?.paymentGateway?.status}</span>
            </div>
            <div className="text-lg 2xl:text-xl font-semibold text-md-dark p-3">
              {"$" + data?.planData?.planPricingData?.price}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionItem;
